<template>
    <div>
        <DailyCheckPage :page="this.page" :title="this.title" :menuNameUpper="menuNameUpper" :menuNameLower="menuNameLower"/>
    </div>
</template>

<script>
    import DailyCheckPage from '@/app/components/DailyCheckPage.vue'
    export default {
        name: 'DailyCheckMenuInput',
        components: {
            DailyCheckPage
        },
        props:{
            page: Number,
            menuId: Number,
            subMenuId: Number,
        },
        computed: {
            menuNameUpper: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'upperButtonName' in button ? button.upperButtonName : ''
            },
            menuNameLower: function () {
                const button = this.$store.getters['buttons/topButton'](this.menuId)
                return 'lowerButtonName' in button ? button.lowerButtonName : ''
            },
            title: function () {
                const button = this.$store.getters['buttons/dailyCheckButton'](this.menuId, this.subMenuId)
                return 'dailyCheckButtonName' in button ? button.dailyCheckButtonName : ''
            }
        },
    }
</script>
